import { Plus, Trash2 } from "lucide-react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Field, Pick } from "./FormBits";
import { CHARGE_TYPES, COLLECTION_MODES, PAY_METHODS } from "./settlementApi";

export const blankCharge = () => ({ charge_type: "late_fee", amount: "", description: "", collection_mode: "bond_deduction", payment_method: "" });

export function CollectionPicker({ mode, method, onMode, onMethod, testid }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      <Field label="How it's collected">
        <Pick value={mode} onChange={onMode} options={COLLECTION_MODES} testid={`${testid}-mode`} />
      </Field>
      {mode === "external_paid" && (
        <Field label="Paid by">
          <Pick value={method} onChange={onMethod} options={PAY_METHODS} testid={`${testid}-method`} />
        </Field>
      )}
    </div>
  );
}

export function ChargeRows({ charges, setCharges }) {
  const upd = (i, patch) => setCharges(charges.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  return (
    <div className="space-y-3">
      {charges.map((c, i) => (
        <div key={i} className="border border-dashed border-[#282828]/10 p-3 space-y-2" data-testid={`settle-charge-row-${i}`}>
          <div className="grid grid-cols-[1fr_110px_32px] gap-2 items-end">
            <Field label="Charge">
              <Pick value={c.charge_type} onChange={(v) => upd(i, { charge_type: v })} options={CHARGE_TYPES} testid={`settle-charge-${i}-type`} />
            </Field>
            <Field label="Amount $">
              <Input type="number" min="0" step="0.01" value={c.amount} onChange={(e) => upd(i, { amount: e.target.value })} className="h-9" data-testid={`settle-charge-${i}-amount`} />
            </Field>
            <Button type="button" variant="ghost" size="sm" onClick={() => setCharges(charges.filter((_, j) => j !== i))} className="h-9 px-2" data-testid={`settle-charge-${i}-remove`}>
              <Trash2 className="w-3.5 h-3.5 text-red-500" />
            </Button>
          </div>
          <Input placeholder="What the customer sees (e.g. 2 days late)" value={c.description} onChange={(e) => upd(i, { description: e.target.value })} className="h-9 text-[12px]" data-testid={`settle-charge-${i}-desc`} />
          <CollectionPicker mode={c.collection_mode} method={c.payment_method} onMode={(v) => upd(i, { collection_mode: v })} onMethod={(v) => upd(i, { payment_method: v })} testid={`settle-charge-${i}`} />
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => setCharges([...charges, blankCharge()])} className="text-[11px] border-[#9A7B4F]/30 text-[#9A7B4F]" data-testid="settle-add-charge-btn">
        <Plus className="w-3 h-3 mr-1" /> Add charge
      </Button>
    </div>
  );
}
